// External Imports
import { useState } from "react";
import { MdClose } from "react-icons/md";

// Internal Imports
import { requestAdminAPI } from "../../api/posh-api";
import Modal from "../UI/Modal";
import Heading from "../UI/Heading";
import DetailPair from "../UI/DetailPair";
import SelectPair from "../UI/SelectPair";
import LoadingSpinnerWrapper from "../UI/LoadingSpinnerWrapper";
import { constructDateObject } from "../../util/format-date";
import uploadFile from "../../util/upload-file";
import LinkPair from "../UI/LinkPair";

/** ========================================================================
 * * UpdateExpenseModal Component
 * This component renders a form to charge an invoice.
 * ========================================================================== */

export default function UpdateExpenseModal({
  open,
  setOpen,
  expense,
  onComplete,
}) {
  const [loading, setLoading] = useState(false);

  /* ====================== MARK AS PAID  ====================== */
  const submitHandler = async () => {
    try {
      setLoading(true);
      const payload = {
        id: expense.id,
        paidVia: document.getElementById("paidVia")?.value,
        datePaid: constructDateObject(
          document.getElementById("datePaid")?.value,
          "15:00:00"
        ).toISOString(),
        status: "succeeded",
      };

      const file = document.getElementById("receipt")?.files[0];
      if (file) {
        const path = `expenses/${expense.id}/${new Date().getTime()}`;
        const url = await uploadFile(path, file, () => {});
        payload.receipt = url;
      }
      await requestAdminAPI("update-expense", payload);
      onComplete && onComplete();
      setOpen(false);
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  };

  if (!expense) return null;
  return (
    <Modal open={open} setOpen={setOpen}>
      <div className="modal lg:max-w-[400px] gap-6">
        <Heading title="Mark Expense Paid" id={expense?.id} isBackArrow={false}>
          <MdClose onClick={() => setOpen(false)} className="icon" />
        </Heading>
        <div className="info lg:grid-cols-2">
          <DetailPair label="Amount" value={`$${expense.amount}`} classes="font-bold text-lg"/>
          <DetailPair
            label="Date Paid"
            edit={true}
            inputOptions={{
              type: "date",
              id: "datePaid",
              defaultValue: new Date().toISOString().split("T")[0],
              required: true,
            }}
          />
          <SelectPair
            label="Paid Via"
            options={[
              { id: "_cash", name: "Cash" },
              { id: "_clover", name: "Paid from PNC Bank" },
              { id: "_zelle", name: "Paid from Chase Bank" },
              { id: "_muhittin-amex", name: "Paid with Muhittin AMEX" },
            ]}
            edit={true}
            inputOptions={{
              id: "paidVia",
            }}
          />
          <LinkPair
            label="Receipt"
            edit={true}
            inputOptions={{
              name: "receipt",
              type: "file",
              accept: "image/*, application/pdf",
            }}
          />
        </div>
        {loading ? (
          <LoadingSpinnerWrapper />
        ) : (
          <div className="grid-cols-2 info">
            <div onClick={() => setOpen(false)} className="btn-secondary">
              Cancel
            </div>
            <button onClick={submitHandler} className="btn-primary">
              Mark as Paid
            </button>
          </div>
        )}
      </div>
    </Modal>
  );
}
